import React from 'react'
import { Spinner } from 'react-bootstrap'
import './style.sass'

const LoadingBlock = ({ wrapperClass, message }) => (
  <div className={`loading-block-container ${wrapperClass}`}>
    <Spinner animation="border" />
    <label>{message}</label>
  </div>
)

export default LoadingBlock